import React from 'react';
import { Link } from 'react-router-dom';
import { FaTelegram, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* ClinAddis Description - Full width on mobile */}
          <div className="footer-section col-span-2 md:col-span-1">
            <h3>ClinAddis</h3>
            <p>A trusted platform connecting health talent and institutions to build leadership, research excellence, and a stronger health workforce in Ethiopia.</p>
          </div>
          
          {/* Quick Links and Social Media - Stack on mobile, side by side on desktop */}
          <div className="col-span-2 md:col-span-2">
            <div className="flex flex-col md:flex-row gap-4">
              
              {/* Quick Links */}
              <div className="footer-section w-full md:flex-1">
                <h3>Quick Links</h3>
                <div className="footer-links flex flex-col space-y-3">
                  <Link to="/">Home</Link>
                  <Link to="/about">About</Link>
                  <Link to="/programs">Programs</Link>
                  <Link to="/events">Events</Link>
                  <Link to="/merch">Shop</Link>
                  <Link to="/join">Join Us</Link>
                </div>
              </div>
              
              {/* Social Media */}
              <div className="footer-section w-full md:flex-1">
                <h3>Social Media</h3>
                <div className="social-links flex flex-col space-y-3">
                  <a href="https://t.me/ClinAddis" target="_blank" rel="noopener noreferrer" className="social-link">
                    <FaTelegram className="social-icon" /> Telegram
                  </a>
                  <a href="https://www.instagram.com/clinaddis?igsh=MXU3dHl0MXNrYmZleg==" target="_blank" rel="noopener noreferrer" className="social-link">
                    <FaInstagram className="social-icon" /> Instagram
                  </a>
                  <a href="https://www.linkedin.com/company/clinaddis/" target="_blank" rel="noopener noreferrer" className="social-link">
                    <FaLinkedin className="social-icon" /> LinkedIn
                  </a>
                  <a href="https://www.youtube.com/@MichealTadesse09" target="_blank" rel="noopener noreferrer" className="social-link">
                    <FaYoutube className="social-icon"/> YouTube
                  </a>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        
        <div className="copyright">
          <p>If you have any questions please contact Clinaddis Service Desk: <a href="mailto:info@clinaddis.org" className="copyright-link">info@clinaddis.org</a>  | +251 90-1177-700</p>
          <p>&copy; {new Date().getFullYear()} ClinAddis. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;